import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"margin-bottom":"15px","margin-top":"10px"}
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Channels ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Beta")
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"card-toolbar\"><a href=\"#\" class=\"btn btn-icon btn-outline-default h-35px w-35px btn-outline\" style=\"border-radius:50%;margin-left:10px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-download\" viewBox=\"0 0 16 16\"><path d=\"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z\"></path><path d=\"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z\"></path></svg></a></div>", 1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Search ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_alert, {
      style: {"margin-top":"-35px"},
      title: "Setup and download feature will be released in next version! Currently please contact IT team for help.",
      type: "warning",
      "show-icon": "",
      closable: false
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_tag, {
            class: "ml-2",
            type: "warning",
            size: "small",
            style: {"margin-left":"10px"}
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_form, {
          inline: true,
          model: _ctx.formInline,
          class: "demo-form-inline",
          size: "small",
          "label-position": 'right',
          "label-width": "auto",
          ref: "searchForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Channel Name",
              prop: "channelName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formInline.channelName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formInline.channelName) = $event)),
                  placeholder: "Channel Name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Gateway Name",
              prop: "gatewayName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formInline.gatewayName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formInline.gatewayName) = $event)),
                  placeholder: "Gateway Name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_button, {
          onClick: _ctx.resetFormFields,
          icon: _ctx.Search,
          size: "small",
          style: {"float":"right"}
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick", "icon"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmitSearchForm,
          icon: _ctx.Search,
          size: "small",
          style: {"float":"right","margin-right":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick", "icon"])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.latipayChannelsRef,
      style: {"width":"100%"},
      height: "450",
      size: "default"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "id",
          label: "ID",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "region",
          label: "Region",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "country",
          label: "Country",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "gateway.type",
          label: "Type",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel.name",
          label: "Channel",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "gateway.name",
          label: "Gateway",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "scenario",
          label: "Scenario",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cryptoNetwork",
          label: "Crypto Network",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasFee",
          label: "MDR?",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "feeRate",
          label: "MDR Value",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "maxFee",
          label: "Capped MDR",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "minFee",
          label: "Minimum MDR",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasFixedFee",
          label: "Transaction Fee?",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "fixedFeeCurrency",
          label: "Transaction Fee Currency",
          width: "210"
        }),
        _createVNode(_component_el_table_column, {
          prop: "fixedFee",
          label: "Transaction Fee",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasRefundFee",
          label: "Refund Fee?",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "refundFeeCurrency",
          label: "Refund Fee Currency",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          prop: "refundFee",
          label: "Refund Fee",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasSettlementFee",
          label: "SettlementFee?",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "settlementFeeCurrency",
          label: "SettlementFee Currency",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "settlementFee",
          label: "Settlement Fee",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "settlementCycleDays",
          label: "Settlement CycleDays",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasChargebackFee",
          label: "ChargebackFee?",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "chargebackFeeCurrency",
          label: "ChargebackFee Currency",
          width: "210"
        }),
        _createVNode(_component_el_table_column, {
          prop: "chargebackFee",
          label: "Chargeback Fee",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasRollingReserve",
          label: "RollingReserve?",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "rollingReserveRate",
          label: "RollingReserve Rate",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          prop: "rollingDays",
          label: "Rolling Days",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasDiscount",
          label: "Disacount?",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "discountRate",
          label: "Disacount Rate",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "discountAmount",
          label: "Disacount Amount",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hasConversion",
          label: "Conversion?",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "conversionRate",
          label: "Conversion Rate",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          label: "Created At",
          width: "250"
        }, {
          default: _withCtx((lpChannel) => [
            _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(lpChannel.row.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "updatedAt",
          label: "Updated At",
          width: "250"
        }, {
          default: _withCtx((lpChannel) => [
            _createTextVNode(_toDisplayString(_ctx.DateTimeUtils.parseDateTime(lpChannel.row.updatedAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "tier",
          label: "Tier",
          width: "110",
          fixed: "right"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_pagination, {
      currentPage: _ctx.pageNumberRef,
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageNumberRef) = $event)),
      "page-size": _ctx.pageSizeRef,
      small: _ctx.small,
      "page-sizes": [20, 30, 40, 50],
      layout: "total,sizes, prev, pager, next",
      total: _ctx.totalRef,
      style: {"float":"right"},
      onSizeChange: _ctx.updatePageSize,
      onCurrentChange: _ctx.updatePageNumber
    }, null, 8, ["currentPage", "page-size", "small", "total", "onSizeChange", "onCurrentChange"])
  ], 64))
}